import { render } from "./filter-search-product-grid.vue?vue&type=template&id=3da81a72"
import script from "./filter-search-product-grid.vue?vue&type=script&lang=js"
export * from "./filter-search-product-grid.vue?vue&type=script&lang=js"

import "./filter-search-product-grid.vue?vue&type=style&index=0&id=3da81a72&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__